import { Dispatch, useMemo } from 'react';
import { isFunction } from 'lodash-es';

export const useActions = <Types extends object, CustomActionCreators>(
  types: Types,
  dispatch: Dispatch<{
    type: string;
    payload: unknown;
  }>,
  customActionCreators: CustomActionCreators
) =>
  useMemo(
    () =>
      Object.entries({ ...types, ...customActionCreators }).reduce(
        (memo, [type, action]) => ({
          ...memo,
          [type]: isFunction(action)
            ? // apply middleware
              action(dispatch)
            : // support implicit actions
              // TODO: use generic instead of unknow
              (payload: unknown) => dispatch({ type, payload })
        }),
        {} as {
          [k in keyof (Types & CustomActionCreators)]: (
            // TODO: use generic instead of unknow
            payload: unknown
          ) => void;
        }
      ),
    [customActionCreators, dispatch, types]
  );
